(function () {
	document.querySelectorAll("[data-toggle]").forEach((element) => {
		let toggleElement = document.querySelector(element.dataset.toggle);
		element.setAttribute("aria-controls", element.dataset.toggle);
		console.log(element.dataset.toggleDisableScroll);

		// On init all items will be set as outside of the tabindex
		if (toggleElement) {
			toggleElement.querySelectorAll("*").forEach((link) => {
				if (link.matches("button, a")) {
					link.setAttribute("tabindex", "-1");
				}
			});

			if (element.dataset.disableScroll === true) {
				console.log("is not scrolling");
			}
		}

		element.addEventListener("click", (event) => {
			handleToggleElement();
		});

		// Add escape key listener
		document.addEventListener("keydown", (event) => {
			// Ignore IME composition
			if (event.isComposing || event.keyCode === 229) {
				return;
			}

			// Close menu with ESC key
			if (event.key === "Escape") {
				if (toggleElement.classList.contains("active")) {
					handleToggleElement();
				}
			}
		});

		function handleToggleElement() {
			element.classList.toggle("active");
			let isActive = false;

			if (toggleElement) {
				toggleElement.classList.toggle("active");

				if (toggleElement.classList.contains("active")) {
					// Opening
					isActive = true;
					toggleElement.setAttribute("aria-expanded", "true");

					toggleElement.querySelectorAll("*").forEach((link) => {
						if (link.matches("button, a")) {
							link.setAttribute("tabindex", "0");
						}
					});
				} else {
					// Closing
					isActive = false;
					toggleElement.setAttribute("aria-expanded", "false");

					toggleElement.querySelectorAll("*").forEach((link) => {
						if (link.matches("button, a")) {
							link.setAttribute("tabindex", "-1");
						}
					});

					// Focus back on the button when closing
					element.focus();
				}

				if (isActive && element.dataset.toggleDisableScroll) {
					console.log("clicked disabled && isActive");

					document.querySelector("body").style.overflow = "hidden";
				} else if (element.dataset.toggleDisableScroll) {
					console.log("clicked disabled && !isActive");
					document.querySelector("body").style.overflow = "";
				}

				const event = new CustomEvent("btToggled", {
					bubbles: true,
					detail: {
						isActive: isActive,
					},
				});
				element.dispatchEvent(event);
			}
		}
	});
})();
